<template>
  <div id="app">
    <div v-loading.fullscreen.lock="loading" :element-loading-text="loadingText">
    </div>

    <div id="wrapper">
      <main-top-tabs></main-top-tabs>

      <main-top-bar></main-top-bar>

      <main-left-menu></main-left-menu>

      <div class="content-page">
        <div :class="['content', contentRightBarClass]">
          <div class="container">
            <keep-alive>
              <router-view v-if="isSessionLoaded"></router-view>
            </keep-alive>
          </div>
        </div>
      </div>
    </div>

    <main-custom></main-custom>
    <main-modals></main-modals>
    <main-bottom-right-buttons></main-bottom-right-buttons>
  </div>
</template>

<script>
  import MainTopBar from '../MainTopBar.vue'
  import MainLeftMenu from '../MainLeftMenu.vue'
  import MainBottomRightButtons from '../MainBottomRightButtons.vue'
  import MainTopTabs from '../MainTopTabs.vue'
  import MainModals from '../MainModals.vue'
  import MainCustom from '../../../../../../src/components/Templates/MainCustom.vue'

  let $ = window.$

  export default {
    name: 'main-layout',
    components: {
      MainModals,
      MainTopTabs,
      MainBottomRightButtons,
      MainLeftMenu,
      MainTopBar,
      MainCustom
    },
    data () {
      return {
        loading: false,
        loadingText: 'Chargement en cours ...'
      }
    },
    computed: {
      isSessionLoaded () {
        return this.$store.getters['app/session/isLoaded']
      },
      contentRightBarClass () {
        if (this.$store.getters['user_preferences/current'].payload.task_lists.display_mode === 'into') {
          return 'right-bar-condensed'
        } else {
          return ''
        }
      }
    },
    methods: {
      checkNewVersion: function () {
        let self = this

        let interval = setInterval(function () {
          self.$http.get('static/git_version').then((response) => {
            let currentVersion = self.$store.state.app.ui.version
            let remoteVersion = response.data.toString().trim()

            if (remoteVersion !== '' && currentVersion !== remoteVersion) {
              clearInterval(interval)
              self.$message.info({
                message: 'Une nouvelle version de l\'interface est disponible. Actualisez cette page pour bénéficier de la mise à jour.'
              })
            }
          })
        }, 60000)
      },
      handleAlwaysDisplayedBar: function () {
        if (this.$store.getters['user_preferences/current'].payload.task_lists.always_displayed) {
          $('#wrapper').toggleClass('right-bar-enabled')
        }
      },
      loadVersion: function () {
        let self = this

        this.$http.get('static/git_version').then((response) => {
          let version = response.data.toString().trim()
          if (version === 'dev') {
            self.$message.info({
              message: 'Connecté sur l\'interface en version développement.'
            })
          } else {
            self.$message.success('Connecté sur l\'interface (rev ' + version + ')')
          }

          this.$store.commit('app/ui/setVersion', version)
        })
      }
    },
    mounted () {
      let self = this

      // If we revieve the disconnected event from nexus, logout
      this.$nexus.on('disconnected', () => {
        self.$router.push('/session/login', () => {
          self.$message.error('Votre session a expirée, vous avez été deconnecté')
        })
      })

      // If the template is still loading, display the loader
      if (!this.$store.getters['app/session/isLoaded']) {
        this.loading = true
        this.$store.dispatch('app/session/load').then(() => {
          // When the loading is finished
          self.loadVersion()
          self.checkNewVersion()
          self.handleAlwaysDisplayedBar()
          self.loading = false
        })
      }
    }
  }
</script>

<style>
  .right-bar-enabled .right-bar-condensed {
    padding-right: 245px;
  }
</style>



// WEBPACK FOOTER //
// MainLayout.vue?16ee485a